"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.avatarSizeOptions = exports.BaseAvatar = exports.Avatar = exports.AVATAR_SIZE = exports.AVATAR_COLOR = void 0;
var React = _interopRequireWildcard(require("react"));
var _Text = require("../../components/Text");
var COLORS = _interopRequireWildcard(require("../../styles/variables/_color"));
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _Icon = require("../Icon");
var _StatusIndicator = require("../StatusIndicator");
var _AvatarModule = _interopRequireDefault(require("./Avatar.module.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const AVATAR_SIZE = Object.freeze({
  small: 'small',
  medium: 'medium',
  large: 'large',
  extraLarge: 'extraLarge'
});
exports.AVATAR_SIZE = AVATAR_SIZE;
const avatarSizeOptions = [...Object.keys(AVATAR_SIZE)];
exports.avatarSizeOptions = avatarSizeOptions;
const AVATAR_COLOR = Object.freeze({
  red: COLORS.colorDangerLightest,
  orange: COLORS.colorWarningLightest,
  green: COLORS.colorSuccessLightest,
  blue: COLORS.colorInformationLightest,
  gray: COLORS.colorGrayLightest,
  indigo: COLORS.colorNeutralLightest
});
exports.AVATAR_COLOR = AVATAR_COLOR;
const getAvatarText = function () {
  let text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  const [firstWord, secondWord] = text.split(' ');
  const firstChar = firstWord ? firstWord[0].toUpperCase() : '';
  const secondChar = secondWord ? secondWord[0].toUpperCase() : '';
  return firstChar + secondChar;
};
const AvatarTextDecorator = _ref => {
  let {
    avatarText,
    size,
    className
  } = _ref;
  switch (size) {
    case 'small':
      return /*#__PURE__*/React.createElement(_Text.SubTitleSmall, {
        className: className
      }, avatarText);
    case 'medium':
      return /*#__PURE__*/React.createElement(_Text.SubTitleMedium, {
        className: className
      }, avatarText);
    case 'large':
      return /*#__PURE__*/React.createElement(_Text.SubTitleLarge, {
        className: className
      }, avatarText);
    case 'extraLarge':
      return /*#__PURE__*/React.createElement(_Text.JumboSmall, {
        className: className
      }, avatarText);
  }
};

// mapping of iconSize for each avatar size;
const iconSize = Object.freeze({
  small: 'small',
  medium: 'medium',
  large: 'medium',
  extraLarge: 'large'
});
const AvatarConditionalContent = _ref2 => {
  let {
    imageSrc,
    text,
    iconName,
    size,
    iconType,
    color = 'blue',
    status,
    statusBorderColorToken,
    classNames
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_AvatarModule.default.innerContainer, {
      [_AvatarModule.default.alignCenter]: !imageSrc
    }, classNames?.content),
    style: {
      '--background-color': AVATAR_COLOR[color]
    }
  }, !!status && /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_AvatarModule.default.statusIndicatorWrapper, _AvatarModule.default[size])
  }, /*#__PURE__*/React.createElement(_StatusIndicator.StatusIndicator, {
    status: status,
    withBorder: true,
    borderColorToken: statusBorderColorToken
  })), imageSrc ? /*#__PURE__*/React.createElement("img", {
    src: imageSrc,
    alt: "Avatar",
    className: (0, _classify.default)(_AvatarModule.default.avatar, classNames?.image)
  }) : iconName ? /*#__PURE__*/React.createElement(_Icon.Icon, {
    name: iconName,
    type: iconType,
    size: iconSize[size],
    className: classNames?.icon
  }) : text ? /*#__PURE__*/React.createElement(AvatarTextDecorator, {
    avatarText: getAvatarText(text),
    size: size,
    className: classNames?.text
  }) : null);
};
const Avatar = /*#__PURE__*/React.forwardRef((_ref3, ref) => {
  let {
    classNames,
    size = AVATAR_SIZE.medium,
    imageSrc,
    text,
    style,
    iconName,
    iconType,
    color,
    ring = false,
    status,
    statusBorderColorToken
  } = _ref3;
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_AvatarModule.default.container, {
      [_AvatarModule.default.extraLargeSize]: size === 'extraLarge',
      [_AvatarModule.default.largeSize]: size === 'large',
      [_AvatarModule.default.mediumSize]: size === 'medium',
      [_AvatarModule.default.smallSize]: size === 'small'
    }, classNames?.wrapper),
    style: style,
    ref: ref
  }, ring ? /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_AvatarModule.default.ring, classNames?.ring)
  }, /*#__PURE__*/React.createElement("div", {
    className: _AvatarModule.default.whiteCircle
  }, /*#__PURE__*/React.createElement(AvatarConditionalContent, {
    imageSrc: imageSrc,
    text: text,
    iconName: iconName,
    iconType: iconType,
    color: color,
    size: size,
    status: status,
    statusBorderColorToken: statusBorderColorToken,
    classNames: classNames
  }))) : /*#__PURE__*/React.createElement(AvatarConditionalContent, {
    imageSrc: imageSrc,
    text: text,
    iconName: iconName,
    iconType: iconType,
    color: color,
    size: size,
    status: status,
    statusBorderColorToken: statusBorderColorToken,
    classNames: classNames
  }));
});
exports.Avatar = Avatar;
const BaseAvatar = _ref4 => {
  let {
    classNames,
    size = AVATAR_SIZE.medium,
    text = '',
    style,
    color = 'blue'
  } = _ref4;
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_AvatarModule.default.container, {
      [_AvatarModule.default.baseExtraLargeSize]: size === 'extraLarge',
      [_AvatarModule.default.baseLargeSize]: size === 'large',
      [_AvatarModule.default.baseMediumSize]: size === 'medium',
      [_AvatarModule.default.baseSmallSize]: size === 'small'
    }, classNames?.wrapper),
    style: {
      ...style,
      background: AVATAR_COLOR[color]
    }
  }, /*#__PURE__*/React.createElement(AvatarTextDecorator, {
    avatarText: text,
    size: size,
    className: classNames?.text
  }));
};
exports.BaseAvatar = BaseAvatar;